module.exports = __webpack_public_path__ + "static/media/extraImage4.bdc97c37.png";